
import React, { Component } from 'react';

export default class Learn extends Component {
    state = {
        value: 0,
      };
    render(){
        return(
            <div>
                    <h5>About</h5>
                    <br /> <br /> <br />
                    Welcome to DesignLove Software
                       <br /> <br /> <br />
                       A leading and modern
                       software consultancy focusing on delivery,service and quality excellence.
                       <br /> <br />
               
                       We work with our clients
                       to deliver the very best software in the form of apps (mobile or web or desktop) 
                       as well as other software and data solutions.
                       <br /> <br />
                       Our key products are Enterprise .NET and JS Components -
                       some of these are fully built or component based (add-on) and 
                       these are designed and built with C#, ReactJS, NodeJS and Data or Component APIs.
                       <br /> <br />
                       We can tailor any of our product or solution to meet your business's needs.
                       <br /> <br />
                       The different type of industries we have worked with shows our agility and
                       robustness of experience. These include: <br />
                       Public Services and Gov<br />
                       Retail Banking<br />
                       Private and Small Local Businesses - Shops to Restaurants to small Tailors<br />
                       Utilities Market<br />
                       Digital Design Houses<br />
                       <br /> <br />
                       DesignLove Software is a company that was start by Shuaib Masoud, an engineer with passion
                       for web technologies whether big or small. He has built and worked successfully with many large national 
                       and international firms in the UK such as NHS and it's largest Hospitals in Scotland, Scottish Government, Lloyds Bank, Atos Sky TV, RBS
                       as well as mnay smaller medium sized companies.
                       <br /> <br />
                       Contact us today for a no obligation consultation and informal chat. <br />
            </div>
        );
    }
  }


// WEBPACK FOOTER //
// ./src/components/About.js